export default {
  name: "profiledown",
  box: 5,
  svg: `<path
fill-rule="evenodd"
clip-rule="evenodd"
d="M7.13777 1.35953L6.45757 0.848138C6.43096 0.828265 6.39671 0.819945 6.36141 0.82087C6.32664 0.823181 6.29423 0.837739 6.27158 0.86131L4.0218 3.18397L1.77361 0.86131C1.75069 0.837739 1.71829 0.823181 1.68351 0.82087C1.64979 0.820177 1.61396 0.828265 1.58736 0.848138L0.907156 1.35953C0.880548 1.37964 0.864215 1.40806 0.861581 1.4388C0.858946 1.46953 0.870274 1.4998 0.893457 1.52291L3.92249 4.59337C3.94751 4.61855 3.98387 4.63334 4.02207 4.63334C4.06026 4.63334 4.09662 4.61879 4.12165 4.59337L7.15173 1.52291C7.17465 1.49957 7.18598 1.46953 7.18361 1.4388C7.18097 1.40806 7.16437 1.37964 7.13777 1.35953Z" fill="fillcolor"
/>`,
};
